export default {
  tab: {
    index: 'Tổng Quan',
    fundamental: 'Tài Chính',
    news: 'Tin Tức',
    technical: 'Kỹ Thuật',
    performance: 'Biến động',
  },
  MY_WATCHLIST: 'Danh mục cá nhân ',
  INDUSTRIES: 'Ngành',
  DERIVATIVES: 'Phái sinh',
  INDEX: 'HĐTL VN30',
  BONDS: 'HĐTL Trái Phiếu',
  PUT_THROUGH: 'Thỏa thuận',
  COVERED_WARRANT: 'Chứng Quyền',
  add: 'Thêm',
  done: 'Xong',
  addToWatchlist: 'Thêm vào Watchlist',
  from: 'Từ',
  to: 'đến',
};
